
import {Component, Vue} from "vue-property-decorator";
import {MdbsCore} from "@/api/tsclient";
import ConfirmDialog from "../ConfirmDialog.vue";
import {currentUserModule, instituteAssignmentModule, studyInstitutesModule, studyModule} from "@/store";
import StudyInstituteEditDialog from "@/components/institute/StudyInstituteEditDialog.vue";
import StudyInstituteCreateDialog from "@/components/institute/StudyInstituteCreateDialog.vue";
import StudyInstituteCreateDto = MdbsCore.StudyInstituteCreateDto;
import IStudyInstituteCreateDto = MdbsCore.IStudyInstituteCreateDto;
import StudyInstituteUpdateDto = MdbsCore.StudyInstituteUpdateDto;
import IStudyInstituteShortDto = MdbsCore.IStudyInstituteShortDto;
import IStudyInstituteUpdateDto = MdbsCore.IStudyInstituteUpdateDto;

@Component({
  components: {
    StudyInstituteCreateDialog,
    StudyInstituteEditDialog,
    ConfirmDialog
  },
})
export default class StudyInstituteTable extends Vue {

  toBeUpdatedItem: IStudyInstituteUpdateDto | null = null;
  showUpdateDialog = false;
  toBeCreatedItem: IStudyInstituteCreateDto | null = null;
  showCreateDialog = false;

  headers: Array<any> = [
    {
      text: "Kennung",
      value: "identifier"
    },
    {
      text: "Anzeigename",
      value: "displayName"
    },
    {
      text: 'Aktionen',
      sortable: false,
      width: '60px',
      value: 'actions'
    }
  ]
  options: any = {
    sortBy: ['displayName'],
    sortDesc: [false]
  };
  search: string = "";

  get canUpdate() {
    return currentUserModule.hasRight("StudyInstituteUpdateCmd");
  }

  get canCreate() {
    return currentUserModule.hasRight("StudyInstituteCreateCmd");
  }

  get studyInstitutes() {
    return studyInstitutesModule.studyInstitutes;
  }

  get loading() {
    return studyInstitutesModule.isLoading;
  }

  get selectedInstituteId() {
    return instituteAssignmentModule.currentStudyInstitute?.id ?? "";
  }

  async mounted() {

  }

  cancelUpdate() {
    this.toBeUpdatedItem = null;
  }

  createInstitute() {
    const studyId = studyModule.study.id;

    this.toBeCreatedItem = new StudyInstituteCreateDto({
      studyId: studyId,
      identifier: undefined,
      displayName: undefined,
      isActive: true,
      maxPatientsCount: 100,
      phone: "",
      fax: ""
    });

    this.showCreateDialog = true;
  }

  async updateInstitute(institute: IStudyInstituteShortDto) {
    await studyInstitutesModule.getStudyInstituteById(institute.id);
    const currentStudyInstitute = studyInstitutesModule.currentStudyInstitute;

    this.toBeUpdatedItem = new StudyInstituteUpdateDto({
      id: currentStudyInstitute.id,
      identifier: currentStudyInstitute.identifier,
      displayName: currentStudyInstitute.displayName,
      isActive: currentStudyInstitute.isActive,
      maxPatientsCount: currentStudyInstitute.maxPatientsCount,
      address: currentStudyInstitute.address,
      zipCode: currentStudyInstitute.zipCode,
      city: currentStudyInstitute.city,
      phone: currentStudyInstitute.phone,
      fax: currentStudyInstitute.fax,
      email: currentStudyInstitute.email,
      investigatorUserId: currentStudyInstitute.investigatorUserId,
      additionalInfo: currentStudyInstitute.additionalInfo
    });

    this.showUpdateDialog = true;
  }

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  selectInstitute(item: IStudyInstituteShortDto, row: any) {
    if (!item) {
      return;
    }
    instituteAssignmentModule.setCurrentStudyInstitute(item);
  }

  getRowStyle(item: IStudyInstituteShortDto) {
    return item.id == this.selectedInstituteId ? 'active' : ''
  }
}

